
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import ProjectGallery from '@/components/feature/ProjectGallery';
import { narrativeProjects } from '@/mocks/projects';
import { useTranslation } from 'react-i18next';

export default function Narrative() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Main Content */}
      <main className="pt-20">
        {/* Page Header */}
        <section className="pt-32 pb-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                NARRATIVE
              </h1>
            </div>
          </div>
        </section>

        {/* Projects Gallery - Full Width */}
        <section className="pb-16">
          <div className="w-full">
            <ProjectGallery projects={narrativeProjects} />
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
